import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AppointmentService} from '@shared/services/appointment.service';
import {ToastService} from 'front-base-angular-core/angular/projects/front-base-angular-core/src/public-api';
import {I18nService} from '@shared/services/i18n.service';
import {localeKeyLong} from '@shared/constants/i18n.constants';

@Component({
  selector: 'si-appo-attendance-confirm-dialog',
  templateUrl: './appo-attendance-confirm-dialog.component.html',
  styleUrls: ['./appo-attendance-confirm-dialog.component.scss']
})
export class AppoAttendanceConfirmDialogComponent implements OnInit {
  @Input() displayDialog: boolean;
  @Input() appoId: number;
  @Input() serviceName: string;
  @Input() startDate: number;
  @Input() assistanceTypeName: string;
  @Output() displayDialogChange = new EventEmitter<boolean>();
  @Output() appoAttendanceConfirmed = new EventEmitter<any>();
  hour: string;

  constructor(
    private appointmentService: AppointmentService,
    private toastService: ToastService,
    private i18nService: I18nService
  ) {
  }

  ngOnInit(): void {
    if (this.i18nService.getLanguage() === localeKeyLong.ES || this.i18nService.getLanguage() === localeKeyLong.CA) {
      this.hour = 'h';
    }
  }

  async onClickCloseDialogConfirmAttendance(action: boolean): Promise<void> {
    try {
      if (action) {
        await this.setAppointmentConfirmAttendance();
        this.appoAttendanceConfirmed.emit();
      }
    } finally {
      this.displayDialog = false;
      this.displayDialogChange.emit(this.displayDialog);
    }
  }

  async setAppointmentConfirmAttendance(): Promise<void> {
    await this.appointmentService.setAppointmentConfirmAttendance(this.appoId);
    await this.toastService.success('SI_CONFIRM_ATTENDANCE_SUCCESS');
  }
}
